import React, { useEffect, useState, Suspense, useRef } from 'react';
import { createPortal } from 'react-dom';
import './Header.css';
import { FiShoppingCart } from 'react-icons/fi';
import { useTelegram } from '../../hooks/auth/useTelegram';
import { SlBasket } from "react-icons/sl";
import { GoTrash } from "react-icons/go";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { usePost } from '../../hooks/usePost';
import { useBEARER } from '../../hooks/auth/useBEARER';
import config from '../../config';
import { IoMdPerson } from "react-icons/io";

import { FaUserFriends, FaStore, FaBullhorn } from "react-icons/fa";
import TelegramSafeArea from '../../Components/TelegramSafeArea';

const Register = React.lazy(() => import('../Buyer/Register/Register'));

const CollaborationRequestsModal = React.lazy(() =>
    import('../../Components/Notifications/CollaborationRequestsModal/CollaborationRequestsModal')
);

const SellerMessagesModal = React.lazy(() =>
    import('../../Components/Notifications/SellerMessagesModal/SellerMessagesModal')
);

const SystemMessagesModal = React.lazy(() =>
    import('../../Components/Notifications/SystemMessagesModal/SystemMessagesModal')
);

function Header({ fn_showRegister, hideNotification = false }) {
    const navigate = useNavigate();
    const location = useLocation();

    const [isOpen, setIsOpen] = useState(false);

    const [showCollaborationRequests, setShowCollaborationRequests] = useState(false);
    const [showSellerMessages, setShowSellerMessages] = useState(false);
    const [showSystemMessages, setShowSystemMessages] = useState(false);

    const [avatar, setAvatar] = useState(null);
    const [avatarError, setAvatarError] = useState(false);
    const [isAvatarLoading, setIsAvatarLoading] = useState(true);

    const [urlCollebration, setUrlCollebration] = useState(null);
    const [collebrationCount, setCollebrationCount] = useState(0);

    const [baskets, setBaskets] = useState([]);
    const [showBasketMenu, setShowBasketMenu] = useState(false);

    const [isProfileComplete, setIsProfileComplete] = useState(
        localStorage.getItem('isProfileComplete') === 'true'
    );

    const basketRef = useRef(null);
    const storedToken = localStorage.getItem("ACCESS_TOKEN");
    const hasToken = !!storedToken;

    let avatarClass = 'unregistered';
    if (hasToken) {
        avatarClass = isProfileComplete ? 'registered' : 'incomplete';
    }

    const showLoadingBorder = avatar && !avatarError && isAvatarLoading;

    // 👇 مدیریت کلیک روی آواتار با تشخیص لاگین وب و تلگرام
    const eventToggle = () => {
        const tg = window.Telegram?.WebApp;
        const inTelegram = Boolean(
            tg?.initDataUnsafe?.user?.id ||
            (tg && tg.initData && tg.initData !== '') ||
            window.location.hash.includes('tgWebAppData')
        );

        // اگر خارج از تلگرام بود و لاگین نبود، بلافاصله به لاگین هدایت شود
        if (!inTelegram && !hasToken) {
            navigate('/login');
            return;
        }

        // اگر لاگین بود یا در تلگرام بود، مدال باز شود
        if (typeof fn_showRegister === 'function') {
            fn_showRegister();
        } else {
            setIsOpen(true);
        }
    };

    const { photoUrl } = useTelegram();
    const { userId } = useBEARER();

    const getStartParam = () => {
        return (
            location.state?.startParam ||
            sessionStorage.getItem('telegram_start_param') ||
            window.Telegram?.WebApp?.initDataUnsafe?.start_param ||
            new URLSearchParams(window.location.search).get('tgWebAppStartParam')
        );
    };

    const startParam = getStartParam();

    useEffect(() => {
        const isCollebrationHandled = sessionStorage.getItem('collebration_handled');

        if (startParam === config.telegram_actions.SELLER_REQUEST_COLLABORATION && !isCollebrationHandled) {
            setShowCollaborationRequests(true);
            sessionStorage.setItem('collebration_handled', 'true');
        }
    }, [startParam]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (basketRef.current && !basketRef.current.contains(event.target)) {
                setShowBasketMenu(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleProfileUpdate = () => {
            setIsProfileComplete(localStorage.getItem('isProfileComplete') === 'true');
        };
        window.addEventListener('profileUpdated', handleProfileUpdate);
        window.addEventListener('storage', handleProfileUpdate);
        return () => {
            window.removeEventListener('profileUpdated', handleProfileUpdate);
            window.removeEventListener('storage', handleProfileUpdate);
        };
    }, []);

    const loadBaskets = () => {
        const storedBaskets = localStorage.getItem('baskets');
        if (storedBaskets) {
            try {
                const parsed = JSON.parse(storedBaskets);
                if (Array.isArray(parsed)) {
                    setBaskets(parsed);
                }
            } catch (error) {
                console.error("Error parsing baskets", error);
            }
        }
    };

    useEffect(() => {
        if (userId) {
            setUrlCollebration(`collebration/count/user`);
        }
        loadBaskets();
        window.addEventListener('storage', loadBaskets);
        window.addEventListener('basket-updated', loadBaskets);
        return () => {
            window.removeEventListener('storage', loadBaskets);
            window.removeEventListener('basket-updated', loadBaskets);
        };
    }, [userId]);

    const { data: collebration_count } = usePost(urlCollebration, { user_id: userId });

    useEffect(() => {
        if (photoUrl) {
            setAvatar(photoUrl);
        }
        if (collebration_count) {
            setCollebrationCount(collebration_count.data);
        }
    }, [photoUrl, collebration_count]);

    const getStoreImage = (path) => {
        if (!path) {
            return process.env.PUBLIC_URL + '/images/shop-placeholder.png';
        }
        if (path.startsWith('http')) {
            return path;
        }
        return `${config.api.imageURL}/${path}`;
    };

    const removeBasketItem = (e, indexToRemove) => {
        e.preventDefault();
        e.stopPropagation();
        const updatedBaskets = baskets.filter((_, index) => index !== indexToRemove);
        setBaskets(updatedBaskets);
        localStorage.setItem('baskets', JSON.stringify(updatedBaskets));
        window.dispatchEvent(new Event("storage"));
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', background: '#fff' }}>

                <TelegramSafeArea style={{ background: "#fff" }}>
                    <div className="safe-area-brand">
                        <img
                            src="/images/sabad1_telegram_safe_optimized.png"
                            alt="سبد 1"
                            className="brand-logo"
                        />
                        <span className="brand-text">سبد 1</span>
                    </div>
                </TelegramSafeArea>

                <div className='header-wrapper'>

                    <div
                        className={`avatar ${avatarClass} ${showLoadingBorder ? 'is-loading' : ''}`}
                        onClick={eventToggle}
                    >
                        {!hasToken && (
                            <div className="exclamation-badge">!</div>
                        )}
                        {hasToken && !isProfileComplete && (
                            <div className="warning-badge">!</div>
                        )}

                        <div className="avatar-image-wrapper">
                            {avatar && !avatarError ? (
                                <>
                                    {isAvatarLoading && (
                                        <div className="skeleton-avatar"></div>
                                    )}
                                    <img
                                        src={avatar}
                                        alt="avatar"
                                        onLoad={() => setIsAvatarLoading(false)}
                                        onError={() => {
                                            setAvatarError(true);
                                            setIsAvatarLoading(false);
                                        }}
                                        style={{ display: isAvatarLoading ? 'none' : 'block' }}
                                    />
                                </>
                            ) : (
                                <div className="default-avatar">
                                    <IoMdPerson size={28} color="#ffffff" />
                                </div>
                            )}
                        </div>
                    </div>

                    {!hideNotification && (
                        <div className="notifications-group">
                            <div
                                className="notification-icon-box"
                                onClick={() => setShowCollaborationRequests(true)}
                                title="درخواست‌های همکاری"
                            >
                                <FaUserFriends
                                    size={23}
                                    className={`notification-icon ${collebrationCount > 0 ? "fill" : ""}`}
                                />
                                {collebrationCount > 0 && (
                                    <span className="badge-count">
                                        {collebrationCount}
                                    </span>
                                )}
                            </div>

                            <div
                                className="notification-icon-box"
                                onClick={() => setShowSellerMessages(true)}
                                title="پیام‌های فروشگاه"
                            >
                                <FaStore
                                    size={22}
                                    className="notification-icon"
                                />
                            </div>

                            <div
                                className="notification-icon-box"
                                onClick={() => setShowSystemMessages(true)}
                                title="پیام‌های سیستم"
                            >
                                <FaBullhorn
                                    size={22}
                                    className="notification-icon"
                                />
                            </div>
                        </div>
                    )}

                    {baskets.length > 0 && !hideNotification && (
                        <div
                            className="basket-container"
                            ref={basketRef}
                        >
                            <div
                                className="basket-icon-box"
                                onClick={() => setShowBasketMenu(!showBasketMenu)}
                            >
                                <FiShoppingCart
                                    size={24}
                                    className="basket-icon"
                                />
                                <span className="basket-badge">
                                    {baskets.length}
                                </span>
                            </div>

                            <div className={`basket-dropdown ${showBasketMenu ? 'active' : ''}`}>
                                <div className="dropdown-title">
                                    سبدهای خرید فعال
                                </div>
                                <ul className="basket-list">
                                    {baskets.map((basket, index) => (
                                        <li key={index}>
                                            <div className="basket-item-wrapper">
                                                <Link
                                                    to={`/Shop`}
                                                    className="basket-item-link"
                                                    onClick={() => {
                                                        sessionStorage.setItem("store", JSON.stringify({
                                                            id: basket.store?.id,
                                                            title: basket.store?.title,
                                                            message: basket.store?.message,
                                                            image_banner: basket.store?.image_banner,
                                                            image_logo: basket.store?.image_logo,
                                                            send_cost_price: basket.store?.send_cost_price,
                                                            card_number: basket.store?.card_number,
                                                            theme_json: basket.store?.theme_json
                                                        }));
                                                        setShowBasketMenu(false);
                                                    }}
                                                >
                                                    <div className="store-item">
                                                        <div className="store-img-wrapper">
                                                            <img
                                                                src={getStoreImage(basket.store?.image_logo)}
                                                                alt={basket.store?.title}
                                                                onError={(e) => {
                                                                    e.target.src = process.env.PUBLIC_URL + '/images/avator.jpg';
                                                                }}
                                                            />
                                                        </div>
                                                        <span className="store-name">
                                                            {basket.store?.title}
                                                        </span>
                                                    </div>
                                                </Link>
                                                <button
                                                    className="basket-remove-btn"
                                                    onClick={(e) => removeBasketItem(e, index)}
                                                    title="حذف این فروشگاه"
                                                >
                                                    <GoTrash
                                                        size={20}
                                                        color='red'
                                                    />
                                                </button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Suspense fallback={null}>
                {isOpen && createPortal(
                    <Register
                        fn_close={() => setIsOpen(false)}
                        isShow={isOpen}
                    />,
                    document.body
                )}

                {showCollaborationRequests && createPortal(
                    <CollaborationRequestsModal
                        isShow={showCollaborationRequests}
                        fn_close={() => setShowCollaborationRequests(false)}
                    />,
                    document.body
                )}

                {showSellerMessages && createPortal(
                    <SellerMessagesModal
                        isShow={showSellerMessages}
                        fn_close={() => setShowSellerMessages(false)}
                    />,
                    document.body
                )}

                {showSystemMessages && createPortal(
                    <SystemMessagesModal
                        isShow={showSystemMessages}
                        fn_close={() => setShowSystemMessages(false)}
                    />,
                    document.body
                )}
            </Suspense>
        </>
    );
}

export default Header;
